<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card shadow-sm border border-3">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <small>Send your information</small>
          </div>
          <form @submit.prevent="handleSubmit">
            <base-input
              class="input-group-alternative mb-2"
              placeholder="Name"
              v-model="form.name"
              :errors="form.errors.name"
            />
            <base-input
              type="email"
              class="input-group-alternative mb-2"
              placeholder="Email"
              v-model="form.email"
              :errors="form.errors.email"
            />
            <div class="position-relative">
              <base-input
                class="input-group-alternative mb-2"
                input-classes="input-icon"
                :placeholder="showPassword ? 'Password' : '********'"
                :type="showPassword ? 'text' : 'password'"
                v-model="form.password"
                :errors="form.errors.password"
              />

              <button 
                type="button"
                class="toggle-password-btn"
                @click="togglePassword"
              >
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
            <div class="position-relative">
              <base-input
                class="input-group-alternative"
                input-classes="input-icon"
                :placeholder="showConfirmationPassword ? 'Confirm Password' : '********'"
                :type="showConfirmationPassword ? 'text' : 'password'"
                v-model="form.password_confirmation"
              />
              
              <button 
                type="button"
                class="toggle-password-btn"
                @click="toggleConfirmationPassword"
              >
                <i :class="showConfirmationPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
            <div class="text-center">
              <base-button
                type="primary"
                native-type="submit"
                class="my-4 submit"
                :disabled="form.processing"
              >
                Send
              </base-button>
            </div>
            <p>
              Have an account?
              <router-link to="/login">login</router-link>
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "register",
  data: () => ({
    form: {
      name: null,
      email: null,
      password: null,
      password_confirmation: null,
      errors: {},
      processing: false,
    },
    showPassword: false,
    showConfirmationPassword: false,
  }),
  methods: {
    async handleSubmit() {
      this.form.errors = {};
      try {
        await axios.post(
          process.env.VUE_APP_API_BASE_URL + "/register",
          this.form
        );
        this.$notify({
          type: "success",
          message: "Information sent successfully.",
        });
      } catch (error) {
        this.form.errors = error.response.data.errors;
        this.$notify({
          type: "danger",
          message: "Please check the form.",
        });
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmationPassword() {
      this.showConfirmationPassword = !this.showConfirmationPassword;
    },
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}

.toggle-password-btn {
  position: absolute;
  right: 12px;
  top: 20px;
  background: transparent;
  border: none;
  color: #8898aa;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.toggle-password-btn:hover {
  color: #525f7f;
}

/* Ensure the input padding accounts for the icon */
.input-group-alternative input {
  padding-right: 40px;
}
</style>